import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AnalisePostural } from '../analise-postural/analise-postural';
import { HistoricoAnalisePostural } from '../historico-analise-postural/historico-analise-postural';

@Component({
  selector: 'app-analise-postural-controller',
  imports: [CommonModule, AnalisePostural, HistoricoAnalisePostural],
  templateUrl: './analise-postural-controller.html',
  styleUrl: './analise-postural-controller.scss',
})
export class AnalisePosturalController {
  telaExibida: number = 1; // 1 para importação, 2 para histórico

  mudarTela(novaTela: 1 | 2) {
    this.telaExibida = novaTela;
  }
}
